import { ReactNode } from 'react'
import Card from '../ui/Card'
import { MdNearbyError } from "react-icons/md"

interface CardErrorBoundaryProps {
  className?: string
  title?: string
  description?: string
  resetErrorBoundary: () => void
  children?: ReactNode
  sentryEventId?: string
}

const CardErrorBoundary = ({
  className,
  title = "Something went wrong",
  description ="Please refresh the page or contact support if the problem persists.",
  resetErrorBoundary,
  children,
  sentryEventId
}: CardErrorBoundaryProps) => {
  return (
    <div className={`${className} break-inside-avoid min-h-0`}>
      <Card className="!h-full py-8 px-4 md:px-6 text-center w-full flex flex-col justify-center">
        <div className="flex justify-center items-center">
          <MdNearbyError className="mx-auto mb-3 text-[80px] text-[#00CC66]" />
        </div>
        <div className="mx-auto max-w-[330px]">
          <p className="text-[#167b91] mb-1 text-center text-2xl font-semibold">{title}</p>
          <p className="text-slate-600 text-center font-medium mb-4">{description}</p>
        </div>

        {sentryEventId && (
          <div className="mb-4 p-3 bg-slate-100 border border-slate-200 rounded-lg">
            <p className="text-sm text-slate-600 break-words">
              Error ID: <span className="font-mono font-semibold break-all">{sentryEventId}</span>
            </p>
          </div>
        )}

        <div className="flex justify-center items-center">
          <button
            onClick={resetErrorBoundary}
            className="text-slate-900 text-base md:text-lg font-medium rounded-full px-6 py-1 shadow-sm border-2 border-slate-300"
          >
            Try again
          </button>
        </div>
        {children}
      </Card>
    </div>
  )
}

export default CardErrorBoundary